import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BehaviorSubject } from 'rxjs';
import { ConfigAssetLoaderService } from '../config/config-asset-loader.service';
import { INTERCEPTOR_SKIP, InterceptorSkipHeader } from '../interceptor/interceptor.constants';
import { Favorites } from '../../../../shared/src/lib/menu/model/favorites.model';
import { DocumentTeaser } from '@icullen/api/shared';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {


  FAVORITE_API_BASE_URL : string;

  favoriteDocs: Array<string> =new Array<string>();;

  observableFavDocs : BehaviorSubject<string[]> = new BehaviorSubject<string[]>(this.favoriteDocs);
  //favoriteDocs$ : Observable<string[]>;

  constructor(private httpClient: HttpClient,
    private configService : ConfigAssetLoaderService) {

      // configService.getConfigObservable().subscribe((config => {
      //   //console.log(config);
      //   this.FAVORITE_API_BASE_URL=config.apiBaseUrl+'site/favorite/';
      //   this.loadFavoriteDocs();
      //   //this.favoriteDocs$=this.observableFavDocs.asObservable();
      // }))

      this.FAVORITE_API_BASE_URL=configService.getConfig().apiBaseUrl+'site/favorite/';

  }


  removeFavorite(uniqueNumber : string): Observable<any> {
   let headers = new HttpHeaders().set("Accept","application/json");
    headers=headers.append(INTERCEPTOR_SKIP,"");
    return this.httpClient.delete(this.FAVORITE_API_BASE_URL+'remove/'+uniqueNumber,{headers});
  }

  addFavorite(uniqueNumber : string): Observable<any> {
    let headers = new HttpHeaders().set("Accept","application/json");
    headers=headers.append(INTERCEPTOR_SKIP,"");
    return this.httpClient.put(this.FAVORITE_API_BASE_URL+'add/'+uniqueNumber,{},{headers});
  }

  // loadFavoriteDocs2(apiBaseUrl : string): Promise<any>{

  //   this.FAVORITE_API_BASE_URL=apiBaseUrl+'site/favorite/';

  //   return this.httpClient
  //               .get(this.FAVORITE_API_BASE_URL+'uniqueNumbers',InterceptorSkipHeader)
  //               .toPromise()
  //               .then((response : any) => {
  //                 this.favoriteDocs=response.favorites;
  //                 this.favoriteArrayChangeEvent();
  //               },
  //                 err => console.log(err)
  //               );
  // }


  loadFavoriteDocs() {
    this.httpClient.get<any>(this.FAVORITE_API_BASE_URL+'uniqueNumbers',InterceptorSkipHeader).subscribe(
        favorites => {
          this.favoriteDocs=favorites;
          this.favoriteArrayChangeEvent();
        }
      );
  }

  favoriteArrayChangeEvent(){
    this.observableFavDocs.next(this.favoriteDocs);
  }

  isFavorite(uniqueNumber : string){
    return this.favoriteDocs.indexOf(uniqueNumber) > -1 ;
  }


  deleteFavoriteFromArray(uniqueNumber : string){
    const index = this.favoriteDocs.indexOf(uniqueNumber);
    if(index > -1){
      this.favoriteDocs.splice(index,1);
    }
    this.favoriteArrayChangeEvent();
    //console.log(this.favoriteDocs);

  }

  addFavoriteToArray(uniqueNumber: any) {
    this.favoriteDocs.push(uniqueNumber);
    this.favoriteArrayChangeEvent();
  }

  getFavoriteDocuments(): Observable<Favorites> {
    return this.httpClient.get<Favorites>(this.FAVORITE_API_BASE_URL);
  }

  updateToLatestFavorite(uniqueNumber : string): Observable<DocumentTeaser> {
    let headers = new HttpHeaders().set("Accept","application/json");
    headers=headers.append(INTERCEPTOR_SKIP,"");
    return this.httpClient.put<DocumentTeaser>(this.FAVORITE_API_BASE_URL+'updateToLatest/'+uniqueNumber,{headers});
  }
}
